import { type JSX, useEffect } from "react";
import { useMutation } from "urql";
import { useRefetchUnreadInspirations } from "../components/UnreadInspirations";
import Inspiration from "./Inspiration";
import { type IInspiration, markReadMutation } from "./query";

interface IProps {
    inspirations: IInspiration[];
}

function InspList({ inspirations }: IProps): JSX.Element {
    const [_, executeMutation] = useMutation(markReadMutation);
    const refetchUnread = useRefetchUnreadInspirations();

    // biome-ignore lint/correctness/useExhaustiveDependencies: Only inspirations is unstable reference.
    useEffect(() => {
        const ids = inspirations.filter((insp) => !insp.read).map((insp) => insp.id);
        if (ids.length === 0) {
            return;
        }
        return () => {
            (async () => {
                await executeMutation({ ids });
                await refetchUnread?.();
            })();
        };
    }, [inspirations]);

    return (
        <>
            {inspirations.map((insp) => (
                <Inspiration inspiration={insp} key={insp.id} />
            ))}
        </>
    );
}

export default InspList;
